import React from 'react';

import { AlertHeader, Container, AlertContent } from '../styles/CustomAlertStyle';

const CustomAlert = ({ title, warning, children }) => {
  const alertType = warning ? 'warning' : 'error';

  return (
    <Container type={alertType}>
      <AlertHeader type={alertType}>{title}</AlertHeader>
      <AlertContent>{children}</AlertContent>
    </Container>
  );
};

export default CustomAlert;
